<div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title">
            <br>
            <h3 class="card-label">Pet Financial</h3>
            <form>
                <div class="row">
                  <div class="col">
                    <input type="date" class="form-control" name="start_date" placeholder="Start Date" [(ngModel)]="start_date" (change)="dateOnChange()">
                  </div>
                  -
                  <div class="col">
                    <input type="date" class="form-control" name="end_date" placeholder="End Date" [(ngModel)]="end_date" (change)="dateOnChange()">
                  </div>
                </div>
            </form>
        </div>
        <div class="card-toolbar">
            <button type="button" class="btn btn-info" (click)="print()"><i class="las la-print"></i> Print Report</button>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">
        <br>
        <table class="table table-sm table-striped">
            <thead>
                <tr>
                    <th></th>
                    <th>
                        Date
                    </th>
                    <th>
                        Invoice No.
                    </th>
                    <th>
                        Charge + Tax
                    </th>
                    <th>
                        <span class="c_blue">Deposit</span>/<span class="c_red">Balance</span>
                    </th>
                    <th>
                        Discount
                    </th>
                    <th>
                        Total Charge
                    </th>
                    <th>
                        Amount Paid
                    </th>
                    <th>
                        Total <span class="c_blue">Deposit</span>/<span class="c_red">Balance</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let item of invoiceService.finance_cr">
                    <td> 
                        <button type="button" class="btn btn-secondary btn-sm" (click)="printinvoice(item.invoice_no)"><i class="las la-receipt"></i></button>                       
                    </td>
                    <td>
                        {{ item.inv_date }}
                    </td>
                    <td>
                        {{ item.invoice_no }}
                    </td>
                    <td>
                        {{ (item.total_charge + item.total_tax)  | currency }}
                    </td>
                    <td>
                        <span [ngClass]="{'c_blue': item.deposit !== 0, 'c_red': item.deposit === 0}">
                            {{ (item.deposit !== 0 ? item.deposit : item.prior_balance) | currency }}
                        </span> 
                    </td>
                    <td>
                        {{ item.Discount | currency}}
                    </td>
                    <td>
                        {{ item.balance_due | currency}}
                    </td>
                    <td>
                        {{ item.amount_paid | currency}}
                    </td>
                    <td>
                        <span [ngClass]="{'c_blue': item.current_balance < 0, 'c_red': item.current_balance >  0}">
                            {{ item.current_balance | currency}}
                        </span> 
                    </td> 
                </tr>
            </tbody>
        </table>

    </div>
</div>

<style>
    .c_blue {
        color:blue
    }
    .c_red {
        color:red
    }
</style>